function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m13 13.01h24v4h-24z",
  fill: "#656d78"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m51 39.01c0 2.76-2.24 5-5 5s-5-2.24-5-5 5-8 5-8 5 5.24 5 8z",
  fill: "#5d9cec"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m33 63h-16c-2.21 0-4-1.79-4-4v-41.99h24v41.99c0 2.21-1.79 4-4 4zm-10-15.99c0 1.101.89 2 2 2 1.101 0 2-.899 2-2v-8-8c0-1.1-.899-2-2-2-1.11 0-2 .9-2 2v2 3 3 3 3z",
  fill: "#e6e9ed"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m23 39.01h4v8c0 1.101-.899 2-2 2-1.11 0-2-.899-2-2v-2-3z",
  fill: "#5d9cec"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m27 31.01v8h-4v-3-3-2c0-1.1.89-2 2-2 1.101 0 2 .9 2 2z",
  fill: "#ccd1d9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m36.998 17.998h-23.993c-.553 0-1-.447-1-1v-4.001c0-.553.447-1 1-1h23.993c.553 0 1 .447 1 1v4.001c0 .553-.447 1-1 1zm-22.993-2h21.993v-2.001h-21.993z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m13.001 59.994c-.553 0-1-.448-1-1l.003-41.996c0-.553.448-1 1-1 .553 0 1 .448 1 1l-.003 41.996c0 .553-.448 1-1 1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m37.002 59.994c-.552 0-1-.447-1-1l-.003-41.996c0-.552.447-1 1-1 .552 0 1 .447 1 1l.003 41.996c0 .552-.447 1-1 1z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m25.029 16c-.553 0-1.005-.447-1.005-1s.442-1 .994-1h.011c.552 0 1 .447 1 1s-.448 1-1 1z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m27 32.002c-.553 0-1-.447-1-1 0-.552-.449-1.001-1.001-1.001s-1.001.449-1.001 1.001c0 .553-.447 1-1 1s-1-.447-1-1c0-1.654 1.347-3.001 3.001-3.001s3.001 1.347 3.001 3.001c0 .553-.447 1-1 1z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m24.999 50c-1.654 0-3.001-1.347-3.001-3.001 0-.553.447-1 1-1s1 .447 1 1c0 .552.449 1.001 1.001 1.001s1.001-.449 1.001-1.001c0-.553.447-1 1-1s1 .447 1 1c0 1.654-1.347 3.001-3.001 3.001z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m22.998 47.999c-.553 0-1-.447-1-1v-15.997c0-.553.447-1 1-1s1 .447 1 1v15.997c0 .553-.447 1-1 1z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m27 47.999c-.553 0-1-.447-1-1v-15.997c0-.553.447-1 1-1s1 .447 1 1v15.997c0 .553-.447 1-1 1z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m27 40.001h-4.002c-.553 0-1-.447-1-1s.447-1 1-1h4.002c.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m24 37h-1.002c-.553 0-1-.447-1-1s.447-1 1-1h1.002c.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m24 43h-1.002c-.553 0-1-.447-1-1s.447-1 1-1h1.002c.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m24 34h-1.002c-.553 0-1-.447-1-1s.447-1 1-1h1.002c.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m24 46h-1.002c-.553 0-1-.447-1-1s.447-1 1-1h1.002c.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m17.003 63.996c-2.758 0-5.002-2.244-5.002-5.002 0-.553.447-1 1-1s1 .447 1 1c0 1.655 1.347 3.002 3.002 3.002.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m33 63.996c-.553 0-1-.447-1-1s.447-1 1-1c1.655 0 3.002-1.347 3.002-3.002 0-.553.447-1 1-1s1 .447 1 1c0 2.758-2.244 5.002-5.002 5.002z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m33 63.996h-15.997c-.553 0-1-.447-1-1s.447-1 1-1h15.997c.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m26 60.997h-2c-.553 0-1-.447-1-1s.447-1 1-1h2c.553 0 1 .447 1 1s-.447 1-1 1z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m25.021 11.006c-.553 0-1.005-.447-1.005-1s.442-1 .994-1h.011c.552 0 1 .447 1 1s-.449 1-1 1z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m27.111 8.884c-.256 0-.512-.098-.707-.293-.779-.779-2.049-.779-2.828 0-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414c1.559-1.561 4.098-1.561 5.656 0 .391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m29.232 6.763c-.256 0-.512-.098-.707-.293-.945-.945-2.2-1.466-3.535-1.466s-2.59.52-3.535 1.466c-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414c1.322-1.323 3.08-2.052 4.949-2.052s3.627.729 4.949 2.052c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m31.354 4.641c-.256 0-.512-.098-.707-.293-3.119-3.119-8.195-3.119-11.314 0-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414c3.898-3.898 10.244-3.898 14.143 0 .391.391.391 1.023 0 1.414-.196.195-.452.293-.708.293z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m45.999 45c-3.309 0-6-2.691-6-6 0-3.073 4.736-8.127 5.276-8.693.377-.395 1.07-.395 1.447 0 .54.566 5.276 5.62 5.276 8.693.001 3.309-2.69 6-5.999 6zm0-12.523c-1.778 2.012-4 5.02-4 6.523 0 2.206 1.794 4 4 4s4-1.794 4-4c0-1.504-2.222-4.512-4-6.523z"
});

var SvgDehumidifier = function SvgDehumidifier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDehumidifier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dehumidifier.12a3fd00.svg";
export { ForwardRef as ReactComponent };